import DraftFieldValue, { fieldValueToDraftFieldValue } from '../../domain/entity/DraftFieldValue'
import EqualityHashMap from '../EqualityHashMap'
import { com } from '@eidu/web'
import FieldId = com.eidu.entity.field.FieldId
import Entity = com.eidu.entity.Entity
import FieldValue = com.eidu.entity.field.FieldValue

const getNonNullFieldsFromEntity = (entity: Entity): ReadonlyMap<FieldId, DraftFieldValue> =>
  new EqualityHashMap<FieldId, DraftFieldValue>(
    Array.from(entity.valuesByFieldId.asJsReadonlyMapView())
      .filter((it): it is [FieldId, FieldValue] => it[1] !== null)
      .map(([id, value]) => [id, fieldValueToDraftFieldValue(id, value)])
  )

export default getNonNullFieldsFromEntity
